import { Skeleton } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC, ReactNode } from 'react';

import { DispatchDate } from '../../utils/dispatch';

interface Props {
  dispatchDate: DispatchDate;
  variant:
    | 'estimation'
    | 'explainer'
    | 'framedExplainer'
    | 'order'
    | 'schedule';
  /** When provided, wraps the label (or skeleton) instead of a default `<p>`. */
  renderLabel?: (label: ReactNode) => ReactNode;
}

export const ProductDispatchDate: FC<Props> = ({
  dispatchDate,
  renderLabel,
  variant,
}) => {
  const { t } = useTranslation('product');

  if (!dispatchDate.weeks) {
    const skeleton = <Skeleton className="mx-auto h-5 w-30" />;
    return <>{renderLabel ? renderLabel(skeleton) : skeleton}</>;
  }

  const shippingNote = dispatchDate.isPast
    ? t(`dispatchDate.${variant}.weeks`, {
        count: dispatchDate.weeks,
      })
    : t(`dispatchDate.${variant}.range`, {
        range: dispatchDate.range,
      });

  if (renderLabel) {
    return <>{renderLabel(shippingNote)}</>;
  }

  return <p>{shippingNote}</p>;
};
